module.exports = __webpack_public_path__ + "static/media/chatbot.03e439c0.png";